import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, retry } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from './app.config';
import { Router } from '@angular/router';
import SimpleCrypto from 'simple-crypto-js';
import { ElectronService } from 'ngx-electron';
// import Store from 'electron-store';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  constructor(private http: HttpClient, public translate: TranslateService, private router: Router, public eservice: ElectronService) {
    this.currency = 'INR'; // Can replace with USD
    this.df_hnscode = '';
    this.df_taxgroup = 'GST 12%';
    this.df_uom = 'PCS';
    this.df_state = 'Gujarat';
    this.tax_inc = false;
    this.taxes = [];
  }
  restItemsUrl = 'https://shriji.techjsr.com/'; // AppConfig.settings.apiServer.url;
  isReady = false;
  isactive = false;
  isloaded = false;
  islogin = false;
  isnew = false;
  licmsg = '';
  orgname = '';
  dfPlaceOfSupply = '';

  private subject = new Subject<any>();
  currency_sym = '₹';
  currency = 'INR'; // Can replace with USD
  df_hnscode: string;
  df_taxgroup: string;
  df_uom: string;
  df_state: string;
  rounding = true;
  tax_inc = false;
  istaxindividual = false;
  taxes: any;
  isadmin = true;
  iswarning = false;
  activationdata = '';

  retrycount = 0;

  th = ['', 'thousand', 'million', 'billion', 'trillion'];
  dg = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
  tn = ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
  tw = ['twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

  sendMessage(message: string) {
    this.translate.get(message).subscribe((res: string) => {
      this.subject.next({ text: res });
    });
  }

  getlocalitem(key) {
    try {
      if (this.eservice.isElectronApp) {
        return this.eservice.ipcRenderer.sendSync('getdata', key);
      } else {
        return localStorage.getItem(key);
      }
    } catch (ex) {
      console.log('localitem error ' + ex);
    }
  }

  setlocalitem(key, value) {
    try {
      if (this.eservice.isElectronApp) {
        this.eservice.ipcRenderer.sendSync('setdata', key, value);
      } else {
        localStorage.setItem(key, value);
      }
    } catch (ex) {
      console.log('localitem error ' + ex);
    }
  }

  removelocalitem(key) {
    try {
      if (this.eservice.isElectronApp) {
        this.eservice.ipcRenderer.sendSync('removedata', key);
      } else {
        localStorage.removeItem(key);
      }
    } catch (ex) {
      console.log('localitem remove error ' + ex);
    }
  }


  getVendorLogo() {
    try {
      if (this.eservice.isElectronApp) {
        let d = this.eservice.ipcRenderer.sendSync('getvendorlogo');
        return d !== '' ? 'data:image/png;base64,' + d : '';
      } else {
        return '';
      }
    } catch (ex) {
      console.log('localitem remove error ' + ex);
    }
  }

  backup(now = 0) {
    try {
      this.getRequest('api/backup/?now=' + now).subscribe((data) => {
        console.log(data);
        if (data.success) {
          if (data.message !== 'Backup already taken') {
            this.sendMessage('Backup Completed Successfully');
          }
        } else {
          this.sendMessage(data.message);
        }
      });
    } catch (ex) {
      console.log(ex);
      this.sendMessage('Oops');
    }
  }

  clearMessage() {
    this.subject.next();
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }


  // Read all REST Items
  checkReady(): void {
    // 1. OPTIMISTIC INSTANT LOAD
    this.isactive = true; // Assume active (allows Login Form to render)
    this.isReady = true;
    this.isloaded = true; // Hide Loading Spinner immediately

    const cu = this.getlocalitem('currentUser');

    // Restore Session (unless explicitly on Login page)
    if (cu && this.router.url.indexOf('/login') === -1) {
      try {
        const user = JSON.parse(cu);
        this.islogin = true;
        this.isadmin = user.admin;

        // Instant Redirect for Staff from Home to Invoice
        // Use window.location.pathname because this.router.url might be '/' during initialization
        if (!this.isadmin && (window.location.pathname === '/' || window.location.pathname === '/home')) {
          this.router.navigate(['/invoice/0']);
        }
      } catch (e) {
        console.log(e);
        this.islogin = false;
        this.router.navigate(['/login']);
      }
    } else {
      // Guest or Explicit Login Page Visit
      if (this.router.url.indexOf('/login') === -1) {
        this.router.navigate(['/login']);
      }
    }

    // 2. BACKGROUND SERVER CHECK (Updates Data & Validates License)
    try {
      this.getRequest('check')
        .subscribe(
          restItems => {
            console.log(restItems);
            if (restItems.success) {
              // Update Data (Taxes, settings, etc.)
              this.isReady = true;
              this.isactive = true; // Confirmed Active by Server
              this.isloaded = true; // Ensure state remains consistent

              this.df_state = restItems.data.statename !== null && restItems.data.statename !== '' ?
                restItems.data.statename : this.df_state;
              this.df_hnscode = restItems.data.df_hnscode;
              this.df_taxgroup = restItems.data.df_tax !== null && restItems.data.df_tax !== '' ?
                restItems.data.df_tax : this.df_taxgroup;
              this.df_uom = restItems.data.df_uom;
              this.tax_inc = restItems.data.tax_inc;
              this.istaxindividual = restItems.data.istaxindividual;
              this.taxes = restItems.taxes;
              const validity = (new Date(restItems.validtill));
              this.orgname = restItems.data.name;
              const diff = ((validity.getTime() - (new Date()).getTime())) / (1000 * 3600 * 24);
              this.licmsg = 'Product is licensed to ' + restItems.data.name
                + (diff <= 10 ?
                  (', Valid till: ' + validity.getDate() + '/' + (validity.getMonth() + 1) + '/' + validity.getFullYear()) : '');
              this.iswarning = (diff <= 10);


              this.getRequest('api/keyvalue/dfPlaceofSupply').subscribe(x => {
                if (x !== null) {
                  this.dfPlaceOfSupply = x.dfPlaceOfSupply;
                }
              });

              // Session check removed from here (Handled Optimistically)

            } else {
              if (restItems.error === 'inactive') {
                this.isactive = false; // Disable UI: Server says inactive/invalid license
                this.isloaded = true;
                this.isReady = true;
                this.isnew = restItems.isnew;
                this.router.navigate(['/activate']);
                this.sendMessage('Product is not activated. Please activate'); // Alert user
              } else {
                this.retryReady();
              }
            }
          },
          error => {
            console.log('communication error :' + error);
            this.retryReady();
          }
        );
    } catch (e) {
      this.sendMessage('Oops ' + e);
      this.retryReady();
    }
  }

  // Read all REST Items
  activate(data: any): void {
    try {
      this.isloaded = false;
      this.getRequestData('setup', data)
        .subscribe(
          restItems => {
            console.log(restItems);
            if (restItems.success) {
              // this.isReady = true;
              // this.isactive = true;
              this.isloaded = true;
              this.retryReady();
            } else {
              if (restItems.message === 'offline') {
                this.isactive = false;
                this.isloaded = true;
                this.isReady = true;
                this.activationdata = restItems.code;
                this.sendMessage('Please find activation data.');
              }
              if (restItems.message === 'inactive') {
                this.isactive = false;
                this.isloaded = true;
                this.isReady = true;
                this.sendMessage('invalid key');
              } else {
                this.isactive = false;
                this.isloaded = true;
                this.isReady = true;
                this.sendMessage(restItems.message);
                // this.retryReady();
              }
            }
          },
          error => {
            this.isloaded = true;
            this.sendMessage('communication error check your intenet connection');
            console.log('communication error :' + error);
            // this.retryReady();
          }
        );
    } catch (e) {
      this.isloaded = true;
      this.sendMessage('Oops ' + e);
      // this.retryReady();
    }
  }
  retryReady() {
    this.retrycount++;
    if (this.retrycount > 10) {
      this.retrycount = 0;
      this.isloaded = true;
      this.sendMessage('APP.ConnectionFailed');
      return;
    }

    setTimeout(() => {
      this.checkReady();
    }, 5000);
  }

  // Rest Items Service: Read all REST Items
  getRequest(path) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'my-auth-token'
      })
    };
    return this.http
      .get<any>(this.restItemsUrl + path, httpOptions)
      .pipe(map(data => data, error => error
      ));
  }
  getRequestHTML(path) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'text/html',
        'Authorization': 'my-auth-token'
      }),
      responseType: 'text' as 'json'
    };
    return this.http
      .get<any>(this.restItemsUrl + path, httpOptions)
      .pipe(map(text => text, error => error
      ));
  }

  getRequestXls(path) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/vnd.openxmlformats',
        'Authorization': 'my-auth-token'
      }),
      responseType: 'blob' as 'json'
    };
    return this.http
      .get<any>(this.restItemsUrl + path, httpOptions)
      .pipe(map(text => text, error => error
      ));
  }
  // Rest Items Service: Read all REST Items
  getRequestData(path, data) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'my-auth-token'
      })
    };

    return this.http
      .post<any>(this.restItemsUrl + path, data, httpOptions)
      .pipe(map(d => d, error => error));
  }

  putRequestData(path, data) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'my-auth-token'
      })
    };

    return this.http
      .put<any>(this.restItemsUrl + path, data, httpOptions)
      .pipe(map(d => d, error => error));
  }

  deleteRequest(path) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'my-auth-token'
      })
    };

    return this.http
      .delete<any>(this.restItemsUrl + path, httpOptions)
      .pipe(map(d => d, error => error));
  }


  encrypt(value) {
    const simpleCrypto = new SimpleCrypto('02@#kp@KF-32MN#@sdgle0KK#%)');
    return (simpleCrypto.encrypt(value));
  }


  decrypt(value) {
    const simpleCrypto = new SimpleCrypto('02@#kp@KF-32MN#@sdgle0KK#%)');
    return (simpleCrypto.decrypt(value));
  }

  toWords(val: number) {
    let s = val.toString();
    if (this.currency === 'INR') {
      const a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ',
        'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ', 'sixteen ', 'seventeen ', 'eighteen ', 'nineteen '];
      const b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
      s = s.indexOf('.') !== -1 ? s.substr(0, s.indexOf('.')) : s;
      if ((s = s.toString()).length > 9) { return ''; }
      const n = ('000000000' + s).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
      if (!n) { return; } let str = '';
      str += (n[1] !== '00') ? this.translate.instant(a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) +
        this.translate.instant('crore') + ' ' : '';
      str += (n[2] !== '00') ? this.translate.instant(a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) +
        this.translate.instant('lakh') + ' ' : '';
      str += (n[3] !== '00') ? this.translate.instant(a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) +
        this.translate.instant('thousand') + ' ' : '';
      str += (n[4] !== '0') ? this.translate.instant(a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) +
        this.translate.instant('hundred') + ' ' : '';
      str += (n[5] !== '00') ? ((str !== '') ? 'and ' : '') +
        this.translate.instant(a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + this.translate.instant('only') + ' ' : '';
      return str;
    } else {
      s = s.replace(/[\, ]/g, '');
      if (s !== parseFloat(s).toString()) { return ''; }
      let x = s.indexOf('.');
      if (x === -1) { x = s.length; }
      if (x > 15) { return ''; }
      const n = s.split('');
      let str = '';
      let sk = 0;
      for (let i = 0; i < x; i++) {
        if ((x - i) % 3 === 2) {
          if (n[i] === '1') {
            str += (this.tn[Number(n[i + 1])]) + ' ';
            i++;
            sk = 1;
          } else if (n[i] !== '0') {
            str += this.tw[Number(n[i]) - 2] + ' ';
            sk = 1;
          }
        } else if (n[i] !== '0') {
          str += this.dg[n[i]] + ' ';
          if ((x - i) % 3 === 0) { str += 'hundred '; }
          sk = 1;
        }

        if ((x - i) % 3 === 1) {
          if (sk) { str += (this.th[(x - i - 1) / 3] !== '' ? this.translate.instant(this.th[(x - i - 1) / 3]) : '') + ' '; }
          sk = 0;
        }
      }
      // Decimal part
      // if (x != s.length) {
      //   var y = s.length;
      //   str += 'point ';
      //   for (i = x + 1; i < y; i++) str += this.dg[n[i]] + ' ';
      // }
      return str.replace(/\s+/g, ' ');
    }
  }
}
